import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { appReducer } from './reducer';
import { SET_CURRENT_USER } from './types';

export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';

const initialState = {
  user: null,
  isAuthenticated: false,
  currentLanguage: 'en',
  authLoading: true 
};

const AppContext = createContext({
  state: initialState,
  dispatch: () => null,
});

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userJson = localStorage.getItem('user');
    
    if (token && userJson) {
      try {
        const user = JSON.parse(userJson);
        dispatch({ type: SET_CURRENT_USER, payload: user });
      } catch (error) {
        console.error('Error restoring auth state:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    
    dispatch({ type: SET_AUTH_LOADING, payload: false });
  }, []);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};